
<h1 *ngIf="merchant | async as doc">{{ doc.name }}</h1>


<p>restaurant-detail works!</p>
